export default "__VITE_ASSET__D9ykD1bq__"